import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import Layout from "../components/Layout";

export default function ThankYou() {
  return (
    <Layout>
      <div className="section-pad flex items-center justify-center">
        <div className="card-surface p-10 max-w-lg text-center">
          <CheckCircle2 size={56} className="text-brand-sage mx-auto" />
          <h1 className="font-display text-4xl font-semibold mt-4 text-brand-ink">You're all set!</h1>
          <p className="mt-3 text-brand-inksoft">Your membership has been activated. A welcome email with login instructions is on its way.</p>
          <Link to="/dashboard" className="btn-primary mt-6" data-testid="thankyou-dashboard">Go to Dashboard</Link>
        </div>
      </div>
    </Layout>
  );
}
